import api from '@/api/Api'
import geocodeApi from '@/api/GeocodeApi'
import apiWithoutAuth from '@/api/ApiWithoutAuth'
import Image from '@models/image/image'
import config from '@/config'
import ax from 'axios'
import Vue from 'vue'
import store from '../store'

const _config = {
  baseURL: 'https://modis.ornl.gov/',
  timeout: 30000
}
let axios = ax.create(_config)

export const state = {
  currentFolder: undefined,
  router: [],
  images: [],
  allImage: [],
  folders: [],
  imageTypes: [],
  imageExamples: [],
  sources: [],
  sourceTypes: [],
  taskUpload: [],
  statusUpload: false,
  listCancel: [],
  page: 1,
  isGrid: true,
  showedImages: []
}

export const getters = {
  currentFolder (state) {
    return state.currentFolder
  },
  router (state) {
    return state.router
  },
  allImage (state) {
    return state.allImage
  },
  sourceTypes (state) {
    return state.sourceTypes
  },
  folders (state) {
    return state.folders
  },
  images (state) {
    return state.images
  },
  imageTypes (state) {
    return state.imageTypes
  },
  imageExamples (state) {
    return state.imageExamples
  },
  sources (state) {
    return state.sources
  },
  taskUpload (state) {
    return state.taskUpload
  },
  isGrid (state) {
    return state.isGrid
  }
}

export const mutations = {
  SET_GRID (state, newValue) {
    state.isGrid = newValue
  },
  SET_PAGE (state, newValue) {
    state.page = newValue
  },
  SET_SHOWED_IMAGES (state, newValue) {
    state.showedImages = newValue
  },
  SET_STATUS (state, newValue) {
    state.statusUpload = newValue
  },
  SET_TASK (state, newValue) {
    state.taskUpload = state.taskUpload.concat(newValue)
  },
  DELETE_STATUS_UPLOAD (state, id) {
    if (id) {
      state.taskUpload = state.taskUpload.filter(val => val.id !== id)
    } else {
      state.taskUpload = state.taskUpload.filter(
        val => val.percent !== 100 || val.error
      )
    }
    if (state.taskUpload.length <= 0) {
      state.statusUpload = false
    }
  },
  SET_LIST_ERROR (state, id) {
    let ind = state.taskUpload.findIndex(val => val.id === id)
    if (ind >= 0) {
      state.taskUpload[ind].error = true
    }
  },
  SET_STATUS_UPLOAD (state, newValue) {
    if (state.taskUpload.length > 0) {
      let task = state.taskUpload.find(val => val.id === newValue.id)
      if (task) {
        // if (!task.cancel) {
        //   let currentTask = state.listCancel.find(val => val.id === task.id)
        //   task.cancel = currentTask.cancel
        // }
        task.percent = newValue.percent
      } else {
        if (newValue.percent !== 100) {
          state.taskUpload.push(newValue)
        }
      }
    } else {
      state.taskUpload.push(newValue)
    }
  },
  SET_CANCEL_UPLOAD (state, newValue) {
    state.listCancel.push(newValue)
  },
  UPDATE_VISIBLE (state, data) {
    state.images.map(val => {
      if (val.id === data.id) {
        val.visible = data.visible
      }
    })
  },
  SET_ALL_IMAGE (state, newValue) {
    state.allImage = newValue
  },
  SET_ROUTER (state, newValue) {
    state.router.push(newValue)
    for (let i = 0; i < state.router.length - 1; i++) {
      state.router[i].disabled = false
    }
  },
  NEW_ROUTER (state, newValue) {
    state.router = newValue
  },
  BACK_TO_FOLDER (state, ind) {
    state.router[ind].disabled = true
    let count = state.router.length - ind - 1
    state.router.splice(ind + 1, count)
  },
  SET_SOURCE_TYPE (state, newValue) {
    state.sourceTypes = newValue
  },
  SET_IMAGERY (state, newValue) {
    state.images = newValue
  },
  SET_FOLDER (state, newValue) {
    state.folders = newValue
  },
  REMOVE_FOLDER: (state, payload) => {
    const index = state.folders.findIndex(val => val.id === payload)
    Vue.delete(state.folders, index)
  },
  SET_IMAGERY_TYPE (state, newValue) {
    state.imageTypes = newValue
  },
  SET_IMAGERY_EXAMPLES (state, newValue) {
    state.imageExamples = newValue
  },
  SET_SOURCE (state, newValue) {
    state.sources = newValue
  }
}

export const actions = {
  getCurrentRouter ({ commit, dispatch, state }) {
    let router = state.router.find(val => val.disabled)
    return router.id
  },
  timeSerial ({ commit, dispatch, state }, form) {
    return api.timeSerialInspect(form).then(response => {
      return response
    })
  },
  spatialAdjustment ({ commit, dispatch, state }, form) {
    return api.spatialAdjustment(form).then(response => {
      return response
    })
  },
  convertToImage ({ commit, dispatch, state }, form) {
    return api.convertToImage(form).then(response => {
      return response
    })
  },
  uploadShapeFile ({ commit, dispatch, state }, data) {
    return api.uploadShapeFile(data).then(res => {
      return res.data
    })
  },
  formulas () {
    return api.formulas()
  },
  deleteFormulas ({ commit, dispatch, state }, id) {
    return api.deleteFormulas(id)
  },
  createNewConfig ({ commit, dispatch, state }, data) {
    return api.createFormulas(data)
  },
  UpdateConfig ({ commit, dispatch, state }, data) {
    return api.updateFormulas(data)
  },
  startUpload ({ commit, dispatch, state }) {
    if (!state.statusUpload) {
      commit('SET_STATUS', true)
      dispatch('submitUpload')
    }
  },
  submitUpload ({ commit, dispatch, state }) {
    let tmp = state.taskUpload.find(val => !val.error)
    if (tmp) {
      dispatch('uploadImage', tmp)
        .then(val => {
          if (val) {
            // store.dispatch('message/setNotification', {
            //   type: 'success',
            //   active: true,
            //   message: val.data.message ? val.data.message : 'Successful'
            // })
          } else {
            store.dispatch('message/setNotification', {
              type: 'error',
              active: true,
              message: `Upload failed`
            })
          }
        })
        .catch(er => {
          commit('SET_LIST_ERROR', tmp.id)
          if (er.status_code === 499) {
            store.dispatch('message/setNotification', {
              type: 'success',
              active: true,
              message: 'Task has been canceled'
            })
          } else {
            store.dispatch('message/setNotification', {
              type: 'error',
              active: true,
              message: er.message ? er.message : 'Task has been canceled'
            })
          }
          commit('SET_STATUS', false)
          let check = state.taskUpload.filter(val => !val.error)
          if (check.length > 0) {
            dispatch('startUpload')
          }
        })
    }
  },
  async uploadImage({ commit, state, dispatch }, request) {
    if (false) {
      const formData = new FormData();
      formData.append('file', request.file)
      formData.append('type', 'image')
      formData.append('fileKey', request.id)
      formData.append('nameFile', request.nameFile)

      return api.uploadImageTest(formData, request.data)
        .then(response => {
          console.log(1, response)
          console.log(state.taskUpload)
          dispatch('createTaskUpload', request)
          commit('DELETE_STATUS_UPLOAD', request.id)
          if (state.taskUpload.length > 0) {
            let tmp = state.taskUpload.find(val => !val.error)
            if (tmp) {
              dispatch('uploadImage', tmp)
            } else {
              commit('SET_STATUS', false)
            }
          } else {
            commit('SET_STATUS', false)
          }
          return response
        })
        .catch(er => {
          store.dispatch('message/setNotification', {
            type: 'error',
            active: true,
            message: er.message ? er.message : 'Server error'
          })
        })
    } else {
      return apiWithoutAuth
        .uploadS3(request.data)
        .then(response => {
          dispatch('createTaskUpload', request)
          commit('DELETE_STATUS_UPLOAD', request.id)
          if (state.taskUpload.length > 0) {
            let tmp = state.taskUpload.find(val => !val.error)
            if (tmp) {
              dispatch('uploadImage', tmp)
            } else {
              commit('SET_STATUS', false)
            }
          } else {
            commit('SET_STATUS', false)
          }
          return response
        })
        .catch(er => {
          store.dispatch('message/setNotification', {
            type: 'error',
            active: true,
            message: er.message ? er.message : 'Server error'
          })
        })
    }
  },
  createTaskUpload ({ commit, state, dispatch }, data) {
    return api
      .createTaskUpload(data.taskData)
      .then(val => {
        store.dispatch('message/setNotification', {
          type: 'success',
          active: true,
          message: val.data.message ? val.data.message : 'Successful'
        })
        store.dispatch('task/refresh', {
          workspaceId: data.taskData.wksId,
          folderId: state.currentFolder
        })
      })
      .catch(er => {
        store.dispatch('message/setNotification', {
          type: 'error',
          active: true,
          message: er.message ? er.message : 'Server error'
        })
      })
  },
  updateUser ({ state }, form) {
    return api.updateUser(form).then(res => {
      store.dispatch('auth/getMe')
      return res
    })
  },
  sharedV2 ({ state }, form) {
    return api.getSharedImages(form).then(response => {
      return response
    })
  },
  removeSharedImage ({ commit, state }, form) {
    return api.removeShareImage(form).then(response => {
      return response
    })
  },
  makeCopyImage ({ commit, dispatch, state }, form) {
    return api.onMakeCopyImage(form).then(response => {
      dispatch('fetchImagery', form.workspaceId)
      return response
    })
  },
  copyToWorkspace ({ commit, state }, form) {
    return api.copyTo(form).then(response => {
      return response
    })
  },
  moveTo ({ commit, state }, form) {
    return api.moveToFolder(form).then(response => {
      return response
    })
  },
  multiMoveImage ({ commit, state }, form) {
    return api.multiMoveToFolder(form)
  },
  renameFolder ({ commit, state }, form) {
    return api.onRenameFolder(form).then(response => {
      return response
    })
  },
  fetchFolder ({ commit, state }, wsId) {
    let form = {
      workspaceId: wsId,
      folderId: state.router.find(item => item.disabled)
        ? state.router.find(item => item.disabled).id
        : undefined
    }
    return api.getDataFolder(form).then(response => {
      const images = response.data.data.images.map(val => new Image(val))
      const folders = response.data.data.folders
      commit('SET_IMAGERY', images)
      commit('SET_FOLDER', folders)
      return response.data.data
    })
  },
  fetchFolderV2 ({ commit, state }, params) {
    if (params.reset) {
      commit('SET_PAGE', 1)
    }
    let form = {
      search: params.search,
      workspaceId: params.workspaceId,
      folderId: state.router.find(item => item.disabled)
        ? state.router.find(item => item.disabled).id
        : undefined,
      page: state.page,
      orderBy: params.orderBy,
      order: params.order
    }
    return api.getDataFolderV2(form).then(response => {
      response.data.data.images.data.map(val => {
        val.nodata = val.nodata.replace('%2B', '+').replace('%2D', '-')
        val.nodata = parseFloat(val.nodata)
        return val
      })

      const images = response.data.data.images.data
        ? response.data.data.images.data.map(val => new Image(val))
        : []
      const folders = response.data.data.folders
      if (params.reset) {
        commit('SET_IMAGERY', [])
        commit('SET_FOLDER', [])
      }
      commit('SET_PAGE', state.page + 1)
      commit('SET_IMAGERY', state.images.concat(images))
      commit('SET_FOLDER', folders)
      return response.data.data.images.data
    })
  },
  getFolder ({ commit, state }, form) {
    return api.getDataFolder(form).then(response => {
      return response.data.data
    })
  },
  align ({ commit, state, dispatch }, form) {
    return api.alignImage(form).then(response => {
      return response
    })
  },
  ARDTool ({ commit, state, dispatch }, form) {
    return api.runARDTool(form).then(response => {
      return response
    })
  },
  createFolder ({ commit, dispatch, state }, form) {
    return api.createFolder(form).then(response => {
      dispatch('fetchFolderV2', {
        workspaceId: form.workspaceId,
        folderId: form.parentId ? form.parentId : undefined
      })
      return response
    })
  },
  fetchSource ({ commit, state }) {
    return api.getSources().then(response => {
      const sources = response.data.data
      sources.map(el => {
        let type = state.sourceTypes.find(
          element => element.id === el.source_type
        )
        if (type) {
          el.maplayer = 'sentinel2map'
          el.icon = 'database.png'
          el.params = type.params ? type.params : undefined
          el.discovery_link = type.discovery_link
            ? type.discovery_link
            : undefined
          el.download_link = type.download_link
            ? type.download_link
            : undefined
          el.code = new URLSearchParams(el.additional_discovery_parameter).get(
            'product'
          )
        }
      })
      commit('SET_SOURCE', sources)
      return sources
    })
  },
  fetchImagery ({ commit, dispatch, state }, workspaceId) {
    return api.getWorkspaceImages(workspaceId).then(response => {
      const images = [
        ...response.data.data.folders.map(val => ({
          ...val,
          itemType: 'folder',
          parentId: val.parent_id
        })),
        ...response.data.data.images.map(
          val =>
            new Image({
              ...val,
              itemType: 'image'
            })
        )
      ]
      commit('SET_ALL_IMAGE', images)
      return images
    })
  },
  getProduct () {
    return api.getProductModis().then(response => {
      return response
    })
  },
  getListTypeSkywatch () {
    let options = {}
    options.url = `https://api.skywatch.co/earthcache/outputs`
    options.method = 'GET'
    options.headers = {
      'Content-Type': 'application/json',
      'x-api-key': '861c184c-5a06-425b-a174-6596e9dadb02'
    }
    return axios(options)
      .then(res => {
        return res
      })
      .catch(er => {
        console.log(er)
      })
  },
  renameImagery ({ commit, dispatch, state }, form) {
    return api.updateWorkspaceImage(form).then(response => {
      dispatch('fetchImagery', form.workspaceId)
      return response
    })
  },
  MultiDeleteImagery ({ commit, state, dispatch, rootState }, form) {
    return api.multiDeleteWorkspaceImage(form).then(response => {
      dispatch('fetchImagery', form.workspaceId)
      return response
    })
  },
  uploadNewImageFromAOI ({ commit, state, rootState }, form) {
    return api.createImageFromAOI(form).then(response => {
      return response
    })
  },
  afterSelectWorkspace ({ commit, dispatch, rootState }) {
    let workspaceId = rootState.auth.currentWorkspace
    commit('NEW_ROUTER', [
      {
        text: 'Root',
        disabled: true,
        id: ''
      }
    ])
    commit('SET_IMAGERY', [])
    commit('SET_FOLDER', [])
    dispatch('fetchImagery', workspaceId)
    dispatch('fetchImageryType')
  },
  searchLocation ({ commit, state, rootState }, keyword) {
    return geocodeApi.searchLocation(keyword)
  },
  onNvdi ({ commit, state, rootState }, form) {
    return api.nvdi(form).then(response => {
      return response
    })
  },
  searchImagesFromPlanet ({ commit, state, dispatch, rootState }, form) {
    return api.getImage(form).then(response => {
      let images = response.data.data
      return images
    })
  },
  clip ({ commit, state, dispatch, rootState }, form) {
    return api.clipImage(form).then(response => {
      let data = response.data.data
      // commit('SET_LIST_IMAGERY', images)
      return data
    })
  },
  clipWithoutTask ({ commit, state, dispatch, rootState }, form) {
    return api.clipImageWithoutTask(form)
  },
  createNewSource ({ commit, state, dispatch, rootState }, form) {
    return api.createSource(form).then(response => {
      dispatch('fetchSource')
      return response
    })
  },
  deleteOtherSource ({ commit, state, dispatch, rootState }, id) {
    return api.deleteSource(id).then(response => {
      dispatch('fetchSource')
      return response
    })
  },
  getListImageFromDataCube ({ commit, state, dispatch, rootState }, form) {
    return api.getOtherImages(form).then(response => {
      return response
    })
  },
  calculateStretch ({ commit, state, dispatch, rootState }, form) {
    return api.calculateStretch(form).then(response => {
      let stretch = response.data.data
      return stretch
    })
  },
  fetchImageryType ({ commit, state }) {
    return api.getImageriesType().then(response => {
      const types = response.data.data
      commit('SET_IMAGERY_TYPE', types)
      return types
    })
  },
  searchSentinel1 ({ commit, state }, form) {
    return api.searchSentinel1(form)
  },
  downloadImage ({ commit, state }, form) {
    form.data.folder_id = state.router.find(item => item.disabled)
      ? state.router.find(item => item.disabled).id
      : undefined
    return api.downloadImage(form)
  },
  checkBalanceTokenARD ({ commit, state, rootState }, form) {
    const payload = {
      environment: form.environment,
      image_ids: form.image_ids,
      tool: form.tool
    }
    return api
      .checkBalanceTokenARD(form.workspaceId, payload)
      .then(response => {
        return response
      })
  },
  imageDifferrence ({ commit, state }, form) {
    return api.imageDifferrence(form)
  },
  getConfig ({ commit, state }) {
    return api.getConfig()
  },
  getBandList ({ commit, state }) {
    return api.getBandList()
  },
  createNewImage ({ commit, state }, form) {
    return api.createNewImage(form)
  },

  deleteImageryFolder: async ({ commit, dispatch }, payload) => {
    await api.deleteImageryFolder(payload)
    dispatch('fetchFolderV2', {
      workspaceId: payload.workspaceId,
      reset: true
    })
  },
  moveImageryFolder: async ({ dispatch }, payload) => {
    const res = await api.moveImageryFolder(payload)
    dispatch('fetchFolderV2', {
      workspaceId: payload.workspaceId,
      reset: true
    })
    return res
  },
  moveImageryImages: async ({ dispatch }, payload) => {
    const res = await api.multiMoveToFolder(payload)
    dispatch('fetchFolderV2', {
      workspaceId: payload.workspaceId,
      reset: true
    })
    return res
  },
  getAllMosaics ({ state }, data) {
    return api.getAllMosaics(data.url, data.params).then(response => {
      return response
    })
  },
  getMosaic ({ state }, data) {
    return api
      .getMosaic(data.url, data.mosaic_id, data.params)
      .then(response => {
        return response
      })
  }
}



// WEBPACK FOOTER //
// ./src/state/modules/imagery.js